export default "__VITE_ASSET__CWWO1gf7__"